<i eIcon
  class="text-elegant clickable"
  (click)="isWikiOpen = true"
  icon="book-open"
></i>

<e-dialog
  size="fullscreen"
  [title]="'Wiki - ' + navigationItem.name"
  [titleData]="navigationItem.config?.wiki"
  [(open)]="isWikiOpen"
  noPadding
  height="100vh"
  >
  @if (isWikiOpen) {
    <e-external-url
      class="dock-y"
      style="position:absolute;width:100%;height:calc(100% - var(--dialog-header-height));"
      [url]="navigationItem.config.wiki"
    ></e-external-url>
  }
</e-dialog>
